import { React, useState, useEffect } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Counter from "yet-another-react-lightbox/plugins/counter";
import "yet-another-react-lightbox/plugins/counter.css";
import parse from 'html-react-parser'
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const Portafolio = () => {
    const [open, setOpen] = useState(false);
    const [galeria, setGaleria] = useState([]);
    //const [index, setIndex] = useState(-1);
    const [currentIndex, setCurrentIndex] = useState(0);

    const selectedGaleria = (n) => {
        const selectedGaleria = portafolio[n].imagenes.galeria.map((imagen) => ({
            src: require(`../imagenes/portafolio/${portafolio[n].imagenes.carpeta}/${imagen}`),
            /*width: 1348, // Ajusta el tamaño según tus necesidades
            height: 767,*/
        }));
        setGaleria(selectedGaleria);
        setCurrentIndex(0);
        setOpen(true);
    };

    const handleDotClick = (index) => {
        setCurrentIndex(index);
    };
    const handleNext = () => {
        if (currentIndex < galeria.length - 1) {
            setCurrentIndex((prevIndex) => prevIndex + 1);
        }
    };
    const handlePrev = () => {
        if (currentIndex > 0) {
            setCurrentIndex((prevIndex) => prevIndex - 1);
        }
    };

    let portafolio = {
        1: {
            titulo: "Tienda Brando",
            url: "https://www.tiendabrando.com.ar/",
            //descripcion: "Es una tienda virtual con catálogo de productos y carro de compra, para la empresa Group Brando, que se dedica al rubro de construcción. Enfocado al diseño responsive para móviles, utiliza tecnologías modernas como React.js. Incluye un panel de control, en donde se puede crear, actualizar o borrar productos. Se realizó una campaña publicitaria en redes sociales y una optimización S.E.O para mejorar el ranking en buscadores como Google.",
            descripcion: "Desarrollamos una tienda virtual para Group Brando, empresa dedicada al rubro de la construcción. El sitio cuenta con catálogo de productos, carro de compras y un panel de administración que permite crear, editar y eliminar artículos de forma sencilla.<br/>El diseño está optimizado para una experiencia fluida tanto en dispositivos móviles como en monitores de escritorio, y fue construido utilizando tecnologías modernas, pensadas para ofrecer velocidad, estabilidad y una experiencia fluida.<br/>Se implementaron campañas publicitarias inteligentes que muestran la tienda en múltiples plataformas digitales, alcanzando a usuarios que buscan activamente productos relacionados con la construcción. Además, se aplicaron técnicas de posicionamiento SEO para mejorar la visibilidad en buscadores como Google.",
            imagenes: {
                carpeta: "tiendabrando",
                portada: "tiendabrando4.jpg",
                galeria: [
                    "tiendabrando1.jpg",
                    "tiendabrando2.jpg",
                    "tiendabrando3.jpg",
                    "tiendabrando4.jpg",
                    "tiendabrando5.jpg",
                    "tiendabrando6.jpg",
                    "tiendabrando7.jpg",
                    "tiendabrando8.jpg",
                    "tiendabrando9.jpg",
                    "tiendabrando10.jpg",
                ],
            },
            fechaIgnaguracion: "06/06/2023",
            version: "2.2",
        },
        2: {
            titulo: "El Cazador GYM",
            url: "https://www.elcazadorgym.com.ar/fitnesscontrol/",
            demo: {
                descripcion: "<p classname='pb-1 font-bold'>Datos para el ingreso:</p><div classname='leading-4'>DNI: 11222333 <br> Contraseña: at4sk6</div>",
                //activar 1 vez por mes
            },
            //descripcion: "Es un gimnasio el cual se le desarrolló un Fitness Control para sus clientes. Las personas que entrenan en el gimnasio cargan las medidas de su cuerpo en un formulario y pueden visualizar su evolución física mes a mes. Incluye un avatar que cambia de forma según el usuario, un historial con comparativas y gráficos. Utiliza tecnologías modernas como React.js. Se puede ingresar desde el navegador de un móvil u otros dispositivos. Cuenta con ingreso con contraseña y registro de usuarios. ",
            descripcion: "Desarrollamos una plataforma web de seguimiento físico para los clientes del gimnasio. Cada persona puede registrar sus medidas corporales a través de un formulario y visualizar su evolución mes a mes, desde cualquier navegador —ya sea en móviles u otros dispositivos.<br/>El sistema incluye un avatar que se adapta a los cambios del usuario, comparativas históricas y gráficos interactivos que muestran el progreso de forma clara y motivadora. Está construido con tecnologías modernas, e incorpora registro de usuarios e ingreso mediante contraseña.<br/>Además, una vez al mes se envía automáticamente una notificación por WhatsApp recordando al usuario que es momento de registrar su progreso, reforzando el hábito y el compromiso con su entrenamiento.<br/>",
            imagenes: {
                carpeta: "elcazadorgym",
                portada: "elcazadorgym1.jpg",
                galeria: [
                    "elcazadorgym1.jpg",
                    "elcazadorgym2.jpg",
                    "elcazadorgym3.jpg",
                    "elcazadorgym4.jpg",
                    "elcazadorgym5.jpg",
                    "elcazadorgym6.jpg",
                ],
            },
            fechaIgnaguracion: "01/11/2024",
            version: "1.1",
        },
        3: {
            titulo: "Juego Jurasico",
            url: "https://juego-jurasico.vercel.app/",
            descripcion: "Inspirado en el famoso juego del dinosaurio de Chrome —ese que aparecía cuando no había conexión a internet— este proyecto busca reformular esa experiencia icónica con una mirada fresca. Conservamos la esencia: reflejos, ritmo y simplicidad, pero le sumamos una capa de diseño y personalidad propia.<br/>La versión beta ya está disponible online. Este juego apunta a capturar la nostalgia y transformarla en algo nuevo, divertido y visualmente atractivo. Un homenaje que no se conforma con repetir, sino que propone.<br/>¿Querés jugarlo?",
            imagenes: {
                carpeta: "juego-jurasico",
                portada: "juego-jurasico1.jpg",
                galeria: [
                    "juego-jurasico1.jpg",
                ],
            },
            fechaIgnaguracion: "30/09/2025",
            version: "0.9 BETA",
        },
        4: {
            titulo: "Bicicletas eléctricas",
            url: "https://www.bicicletaselectricas.com.ar/",
            descripcion: "Lanzamos una tienda online especializada en movilidad urbana, con productos como bicicletas eléctricas, monopatines, bicicletas tradicionales y accesorios. La plataforma permite explorar el catálogo completo, realizar compras de forma sencilla y acceder desde cualquier dispositivo, ya sea móvil o escritorio.<br/>El sitio fue desarrollado con tecnologías modernas, pensadas para ofrecer velocidad, estabilidad y una experiencia de usuario fluida. Para potenciar su alcance, se pusieron en marcha campañas publicitarias segmentadas en redes sociales, que muestran la tienda a personas interesadas en este tipo de productos, logrando presencia en múltiples plataformas digitales.<br/>Las compras pueden realizarse con MercadoPago, en cuotas, con tarjetas de crédito, débito o en efectivo.",
            imagenes: {
                carpeta: "bicicletaselectricas",
                portada: "bicicletaselectricas2.jpg",
                galeria: [
                    "bicicletaselectricas2.jpg",
                    "bicicletaselectricas3.jpg",
                    "bicicletaselectricas4.jpg",
                    "bicicletaselectricas5.jpg",
                    "bicicletaselectricas6.jpg",
                    "bicicletaselectricas7.jpg",
                    "bicicletaselectricas8.jpg",
                ],
            },
            fechaIgnaguracion: "08/10/2025",
            version: "1.0",
        },


    };
    /*
                                      const onInit = () => {
                                          console.log('lightGallery has been initialized');
                                      };
                                  */

    //const singlePhoto = photos.slice(0, 1);

    return (
        <section data-nosnippet className="margen1  bg-[#EEF2FF] dark:bg-[#050817]" id="portafolio">
            <h1 className="titulo1 text-center mb-[3rem] ">Nuestros clientes</h1>
            <div className="portafolio">
                {Object.keys(portafolio).reverse().map((key) => (
                    <div key={key} className=" text-center grid grid-cols-1 lg:grid-cols-12 gap-7 m-2 lg:m-9 ">
                        <div className="order-2 lg:order-1 lg:col-span-6">
                            <h2 className="lg:text-3xl text-xl font-bold">{portafolio[key].titulo}</h2>
                            <div className=" !font-medium !leading-5">

                                <p className="wrapear">{portafolio[key].url}<a href={portafolio[key].url} target="_blank" className=" underline font-semibold text-base underline underline-offset-4 dark:font-medium decoration-[#274dd8]  dark:hover:decoration-[#fff] hover:decoration-[#000]  text-white-600">
                                    <FontAwesomeIcon icon={faArrowUpRightFromSquare} size="md" className="ico-col3 ml-1 text-sm" />
                                </a>
                                </p>
                                <p className=" pt-1 pb-2">{parse(portafolio[key].descripcion)}</p>

                                {portafolio[key].demo && (
                                    <p className=" pt-2">
                                        {portafolio[key].demo.url && (
                                            <a href={portafolio[key].demo.url} target="_blank">
                                                {portafolio[key].demo.url}
                                            </a>
                                        )}
                                        {parse(portafolio[key].demo.descripcion)}
                                    </p>
                                )}
                                <p className="text-sm pt-2"><span className="font-bold">Fecha:</span> {portafolio[key].fechaIgnaguracion}</p>
                                <p className="text-sm"><span className="font-bold">Versión:</span> {portafolio[key].version}</p>
                                <div className="hidden">
                                    video?
                                    <br />
                                    *izq img_ der *click full pantallagaleria redit
                                    <br />
                                    *ver redit celu comportamiento galeria
                                </div>
                            </div>

                        </div>
                        <div className="lg:col-span-6 order-1 lg:order-2">
                            <img
                                src={require(`../imagenes/portafolio/${portafolio[key].imagenes.carpeta}/${portafolio[key].imagenes.portada}`)}
                                alt={portafolio[key].imagenes.galeria[0]}
                                className="object-contain w-full cursor-pointer"
                                onClick={() => {
                                    selectedGaleria(key);
                                }}
                            />
                        </div>
                    </div>
                ))}
            </div>

            <Lightbox
                open={open}
                close={() => setOpen(false)}
                slides={galeria}
                index={currentIndex}
                render={{
                    slide: ({ slide }) => <img src={slide.src} alt="" className="lightbox-image" />,

                }}
                carousel={{
                    finite: true,
                    padding: "0px",
                    navigation: {
                        buttons: ["prev", "next"],
                    },
                    onClickNext: handleNext,
                    onClickPrev: handlePrev,

                }}

                plugins={[Counter]}
                counter={{ container: { style: { top: "unset", bottom: 0, left: 0 } } }}
            />

        </section>
    );
};
